import React from "react";
import { Link } from "react-router-dom";
import zrsLogo from "@/brand/zrsLogo";
import { useI18n } from "@/i18n/I18nProvider";

/** `id` mantém os data-testid estáveis (footer-link-servidores, …) em qualquer idioma. */
const LINKS = [
    { id: "servidores", key: "footer.linkServers", to: "/#servidores" },
    { id: "vips", key: "footer.linkVips", to: "/#vips" },
    { id: "kits", key: "footer.linkKits", to: "/#kits" },
    { id: "regras", key: "footer.linkRules", to: "/" },
    { id: "suporte", key: "footer.linkSupport", to: "/#discord" },
    { id: "discord", key: "footer.linkDiscord", to: "/#discord" },
];

export default function Footer({ discordUrl }) {
    const { t } = useI18n();
    return (
        <footer
            data-testid="footer"
            className="relative pt-16 pb-10 px-6 md:px-8 border-t border-white/5"
            style={{
                background:
                    "linear-gradient(180deg, transparent 0%, rgba(10,7,6,0.9) 100%)",
            }}
        >
            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 pb-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <img
                                src={zrsLogo}
                                alt="ZRS"
                                className="w-11 h-11 object-contain"
                                style={{ filter: "drop-shadow(0 0 10px rgba(255,184,0,0.45))" }}
                            />
                            <div>
                                <div className="font-bold text-lg tracking-wider text-zrs-offwhite">
                                    ZRS
                                </div>
                                <div className="text-[11px] uppercase tracking-[0.3em] text-zrs-metal">
                                    Zaralha Servers
                                </div>
                            </div>
                        </div>
                        <p className="mt-5 text-[13px] text-zrs-offwhite/55 leading-relaxed max-w-sm">
                            {t("footer.about")}
                        </p>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-gold/80 mb-4">
                            {t("footer.navigate")}
                        </div>
                        <ul className="grid grid-cols-2 gap-y-2 gap-x-4">
                            {LINKS.map(({ id, key, to }) => (
                                <li key={id}>
                                    <Link
                                        to={to}
                                        data-testid={`footer-link-${id}`}
                                        className="text-[13px] text-zrs-offwhite/70 hover:text-gold transition-colors"
                                    >
                                        {t(key)}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-gold/80 mb-4">
                            {t("footer.community")}
                        </div>
                        <a
                            href={discordUrl}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-discord-btn"
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-[12px] font-bold border border-gold/30 text-gold hover:bg-gold/10 hover:border-gold/60 transition-colors"
                        >
                            {t("footer.joinDiscord")}
                        </a>
                        <p className="mt-4 text-[12px] text-zrs-metal">
                            {t("footer.ticketSupport")}
                        </p>
                    </div>
                </div>

                <div className="rust-divider" />

                <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px] text-zrs-metal">
                    <div>{t("footer.rights", { year: new Date().getFullYear() })}</div>
                    <div className="flex items-center gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-gold gold-pulse" />
                        {t("footer.status")}
                    </div>
                </div>
            </div>
        </footer>
    );
}
